// extracted by mini-css-extract-plugin
module.exports = {"reportSent":"Report_reportSent__2rVM4","fadeIn":"Report_fadeIn__3zlPi","fadeInOpacity":"Report_fadeInOpacity__1zW_z","callingSaveButton":"Report_callingSaveButton__1zkRw"};